import { Application } from '@hotwired/stimulus';
import AddressForm from './section-p/address-form';
import { SimpleLoginController } from './login/simple-login.stimulus';

export default function init(application: Application) {
    AddressForm();

    SimpleLoginController.register(application);
}
